import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { authService } from '@adaptcx/shared/services/auth'
import { useAuthStore } from '@adaptcx/shared/stores/auth'

import './assets/styles/main.css'
// Centralized AdaptCX app shell (Helix workspace design system). After the CSS
// entry so its base/element styles win over Tailwind Preflight.
import '@adaptcx/shared/styles/appshell/index.css'

const app = createApp(App)
app.use(createPinia())

// v2.5.0 (Ship 11, M-3) — silent-refresh before router mounts. Wrapped
// in an async IIFE because top-level await isn't in the Vite browser
// targets (Chrome 87 / Safari 14 / ES2020).
;(async () => {
  await authService.ensureFreshAccessToken().catch(() => null)
  app.use(router)
  useAuthStore().initFromStorage()
  app.mount('#app')
})()
